import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'

import { formatPrice } from '../../../utils/common'
import styles from './Balance.module.scss'

const Balance = ({
  activeBalance,
  balance = 0,
  handleSendEmailClick,
  isInternalAdmin
}) => {
  const isPreOnboardingCompleted = useSelector(
    s => s.hotelDetails.isPreOnboardingCompleted
  )

  const isSetupCompleted = useSelector(s => s.hotelDetails.isSetupCompleted)

  return (
    <div
      className={[styles.container, isInternalAdmin ? styles.adminContainer : ''].join(
        ' '
      )}
    >
      <ReactTooltip className="balance" />
      <div className={styles.balanceBox}>
        <div className={styles.label}>current balance</div>
        <div className={styles.balanceAmount}>{formatPrice(balance)} USD</div>
      </div>
      <div className={styles.ctaBox}>
        {!isSetupCompleted && !isPreOnboardingCompleted && (
          <button
            className={styles.disabledButton}
            data-tip="Please complete the onboarding process to add payment"
          >
            {isInternalAdmin ? 'Add payment' : 'Pay now'}
          </button>
        )}
        {isSetupCompleted && !isPreOnboardingCompleted && (
          <Link to="/hotel-setup">
            <button>{isInternalAdmin ? 'Add payment' : 'Pay now'}</button>
          </Link>
        )}
        {isPreOnboardingCompleted && (
          <Link to="/billing/payment/check/">
            <button>{isInternalAdmin ? 'Add payment' : 'Pay now'}</button>
          </Link>
        )}
        {isInternalAdmin && (
          <button
            data-tip={activeBalance > 0 ? '' : "Can't send for zero or negative balance"}
            onClick={activeBalance > 0 ? handleSendEmailClick : () => false}
            className={activeBalance > 0 ? '' : styles.disabledButton}
          >
            Send invoice
          </button>
        )}
      </div>
    </div>
  )
}

export default Balance
